import React from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-5 pb-5 px-4 relative overflow-hidden" data-id="element-119">
      <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-120">
        <div className="inline-block bg-brand-accent/15 border border-brand-accent/40 text-brand-accent font-black px-3 py-1 rounded-full text-[10px] md:text-xs mb-3 uppercase tracking-widest" data-id="element-121">
          📚 Kit Completo Educación Financiera Lista
        </div>

        <h1 className="text-2xl md:text-4xl lg:text-5xl font-black mb-3 leading-tight text-white tracking-tight uppercase" data-id="element-122">
          Todo tu año de{' '}
          <span className="text-brand-accent neon-glow" data-id="element-123">
            Educación Financiera
          </span>{' '}
          resuelto en una tarde.
        </h1>

        <p className="text-sm md:text-base mb-3 font-bold text-gray-200 max-w-2xl mx-auto leading-relaxed" data-id="element-124">
          El sistema completo que usan los docentes para planificar, enseñar y
          evaluar sin improvisar —{' '}
          <span className="text-brand-accent font-black" data-id="element-125">
            listo para usar desde hoy.
          </span>
        </p>

        <div className="w-full max-w-[340px] md:max-w-md mx-auto my-2 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 relative" onClick={scrollToCompra} role="button" aria-label="Ver oferta del Kit" data-id="element-126">
          <div className="absolute inset-0 bg-brand-accent/25 blur-3xl rounded-full" data-id="element-127"></div>
          <img src="https://cdn.magicpatterns.com/uploads/58eaWross8h7H2BG84cGy1/my-project-page-1_(10).png" alt="Kit Completo Educación Financiera Lista" className="w-full h-auto drop-shadow-2xl relative z-10" data-id="element-128" />
        </div>

        <p className="text-xs md:text-sm mb-5 font-bold text-gray-300 max-w-xl mx-auto leading-relaxed italic" data-id="element-129">
          Listo para usar. Sin buscar más.
        </p>

        <div className="w-full max-w-sm mx-auto mb-4" data-id="element-130">
          <Button className="text-base md:text-xl py-3 md:py-4 shadow-[0_0_30px_rgba(34,197,94,0.5)]" data-id="element-131">
            💳 → QUIERO MI KIT DE EDUCACIÓN FINANCIERA AHORA
          </Button>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-5 text-[10px] md:text-xs text-gray-400 font-bold" data-id="element-132">
          <div className="flex items-center" data-id="element-133">
            <ShieldCheck className="w-3 h-3 mr-1 text-brand-accent" data-id="element-134" />
            <span data-id="element-135">Garantía 7 días sin preguntas</span>
          </div>
          <div className="flex items-center" data-id="element-136">
            <Lock className="w-3 h-3 mr-1 text-brand-accent" data-id="element-137" />
            <span data-id="element-138">Pago 100% seguro</span>
          </div>
          <div className="flex items-center" data-id="element-139">
            <CreditCard className="w-3 h-3 mr-1 text-brand-accent" data-id="element-140" />
            <span data-id="element-141">Pagas en tu moneda local</span>
          </div>
        </div>
      </div>
    </section>;
}